import _extends from "@babel/runtime-corejs2/helpers/extends";
import React from 'react';
import hoistStatics from 'hoist-non-react-statics'; // 不从'../index.js'引ConfigProvider，避免循环依赖

import ConfigProvider from '../components/config-provider';
export default function withWindConfig(Wrapped) {
  var ConfifgConsumer = ConfigProvider.Consumer;

  var HOC = function HOC(props) {
    return /*#__PURE__*/React.createElement(ConfifgConsumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Wrapped, _extends({}, props, {
        windConfig: context
      }));
    });
  };

  hoistStatics(HOC, Wrapped);
  return HOC;
}